export default "__VITE_ASSET__dd4e5ad8__"